export function shouldFireCheckoutGoogleTag(pickupDate?: Date, rentalDays = 0, now = new Date()) {
  if (!pickupDate || rentalDays < 4) return false;

  // Only fire when the pickup is in the same calendar month & year as right now.
  return (
    pickupDate.getMonth() === now.getMonth() &&
    pickupDate.getFullYear() === now.getFullYear()
  );
}